// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2WUJ7","noInteraction":"EventWrapper_noInteraction__10byq"};